export default __webpack_public_path__ + "static/media/frank-6.a14ac403.jpg";